<template>
  <div class="goods">
    <!-- <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block" style="padding:20px 30px;border-radius: 10px;">
          <van-radio-group v-model="radio">
            <van-radio
              v-for="(item,index) in sendItems"
              :key="index"
              class="radio_item"
              :name="item.id"
              @click="changePay(item.id)"
            >{{item.name}}</van-radio>
          </van-radio-group>
        </div>
      </div>
    </van-overlay> -->
      <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" style="height:50%"> -->
      <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" style="height: max-content" >
      <van-swipe-item
        v-for="(item_head,index_head) in (goods.imgs||'').split(',')"
        :key="index_head"
      >
        <van-image :src="item_head" class="header_img"></van-image>
      </van-swipe-item>
    </van-swipe> -->
    <div class="ProductDescription">
      <span>{{descs}}</span>
    </div>
    <div class='Swiper'>
      <swipe
      :autoplayTime='3000'
        >
        <swipe-item  v-for="(item_head,index_head) in (goods.imgs||'').split(',')"
        :key="index_head">
          <img style="width:100%" :src="item_head + process" >
        </swipe-item>
        </swipe>
    </div>
    <div class="scroll-top" style="z-index:9999;">
        <div class="scroll" v-if="buyShow" v-show="textShow" >{{buy}}</div>
    </div>
    <div class="fontMoney" style="height:70px">
      <!-- <p>{{$t('Pay.money')}}{{ formatPrice(goods.price) }}<span style="font-family: Regular;">{{this.priceTitle}}</span> </p> -->
      <p>{{$t('Pay.money')}}{{ formatPrice(goods.price) }}<span>{{this.priceTitle}}</span> </p>
    </div>
    <van-cell-group>
      <van-cell :border="false" style="padding:0 17px">
        <div class="goods-brief"><span v-if="brief">{{goods.brief}}</span><p>{{goods.prodName}}</p></div>
         <div class="goods-methods">
          <div v-if="itemsIsShow">
            <span v-for="(item,index) in items " :key='index' @click="onNavBar(item.id)">{{item.title}}</span>
          </div>
        </div>
      </van-cell>
    </van-cell-group>
    <div class="center">
      <div style="background: #CCC;border-top-right-radius: 7px;border-top-left-radius: 7px;">
      </div>
      <div class="content" :style="{width:'100%',overflow: 'hidden'}" v-html="goods.content"></div>
      <!-- <div class="switchs" v-if="$route.name=='Detail'">
        <span> 是否显示评论</span> <van-switch v-model="buyShow" size="20" active-color="red" />
      </div> -->
    </div>
    <!-- <div class="switchs" v-if="$route.name=='Detail'">
       <span> 是否显示评论</span> <van-switch v-model="buyShow" size="20" active-color="red" />
    </div>-->
    <div  v-if="buyShow" class="buy-body">
        
        <div class="title-top van-row" style="font-size:16px;font-width:200;padding:20px 0px;padding-left:20px;">{{$t('comment.comment')}}</div>
        <div style="height:150px;margin-left:10px;">
          <div style="margin-left:20px">
            <van-radio-group v-model="radios" direction="horizontal">
              <van-radio name=0  checked-color="red">{{$t('comment.Praise')}}</van-radio>
              <van-radio name=1  checked-color="red">{{$t('comment.Average')}}</van-radio>
              <van-radio name=2  checked-color="red">{{$t('comment.Badreview')}}</van-radio>
            </van-radio-group>
          </div>
          
          <van-field
            v-model="message"
            rows="1"
            autosize
            type="textarea"
            :placeholder="$t('comment.PleaseEnteraComment')"
          />
        </div>
        
        <div style="margin-left:20px;">
          <van-uploader v-model="fileList" :max-count="3" multiple />
        </div>
        <div style="width:90%;margin:20px" v-show="onButtom">
            <van-button type="danger" style="background:#fc2a62 !important" size="large" @click="addProdCommList">{{$t('comment.submitcomments')}}</van-button>
        </div>
        

        <div class="title-top van-row" style="font-size:16px;font-width:200;padding:20px 15px;" v-if="prodCommList.length">评论</div>
        <div v-for="(item,index) in prodCommList" :key="index" class="prod-comm">
          <van-card 
            :desc='item.recTime'
            :title="item.nickName||'匿名用户 '+index+1*10000"
            thumb="../../../static/123.jpg"
          >
          </van-card>
          <div>
              <div style="margin:10px 20px;">{{item.content}}</div>
              <div  class="img-flex">
                  <p  v-if="!item.pics" ></p>
                  <van-image v-else-if="item.pics.indexOf(',')!=-1" width="100"  v-for="(items,indexs) in item.pics.split(',')" :key="indexs" :src='items' />
                  <van-image  v-else width="100" height="100" :src='item.pics' />
              </div>
          </div>
        </div>
    </div> 



    <div class="sheets">
      <van-row class="title">
        <div class="name">
          <span id="ljxd"></span>
        </div>
        <div>
          <span class="money"></span>
          <!-- <span class="orign">{{ formatPrice(comboList.oriPrice) }}</span> -->
        </div>
      </van-row>
      <div class="conts">
        <van-row class="comboSelect">
          <div class="name">
            <!-- <span style="font-size: 22px;font-weight: bold;font-family: Bold;">{{$t('Product_details_page.Package_selection')}}</span> -->
            <span style="font-size: 22px;font-weight: bold;">{{$t('Product_details_page.Package_selection')}}</span>
          </div>
          <van-row class="list" v-for="(itemc,indexc) in goods.comboParams"
              :key="indexc">
            <van-tag
            style="font-size: 14px;padding: 4px;"
              plain
              :type="comboList.index==indexc?'danger':'primary'"
              :color="comboList.index==indexc?'': '#dcdfe6'"
              :text-color="comboList.index==indexc?'': '#000000'"
              @click="toSelectCombo(indexc,itemc.title,itemc.price,itemc.oriPrice,itemc.comboFare)"
            >{{itemc.title}}</van-tag>
          </van-row>
        </van-row>
        <div class="PackagePrice">
          <span></span>
          <span>{{$t('Pay.money')}}{{ formatPrice(comboList.price) }}</span>
        </div>
        <div class="combo" v-for="(item,index) in selectComboList.comboProds" :key="index">
          <!-- <van-row class="goodSheet" type="flex">
              <van-col style="width: 55%;">
                <van-image width="180" height="180" fit="scale-down" :src="pic[index]" />
              </van-col>
              <van-col class="skuName">
                <div class="name">
                  <span>{{properties[index]}}</span>
                </div>
              </van-col>
          </van-row>-->
          <van-row
            style="width: 80%;margin: 2% 5%;font-size: 0.6rem;font-weight: 550;color: #736868"
          >
            <div class="name">
              <!-- <span>{{item.prodName}}</span> -->
            </div>
          </van-row>
          <van-row v-for="(itemp,indexp) in item.productProps" :key="indexp">
            <van-row style="width: 90%;margin: 0 4.5%;">
              <van-cell-group :border="false">
                <van-cell :border="false" style="padding:0">
                  <div class="sku_line_item">
                    <span style="flex:1;padding: 10px 0px;font-size: 22px;color: black;">{{itemp.propName}}</span>
                  </div>
                </van-cell>
              </van-cell-group>

              <van-row class="img-border-row" v-if="indexp==0">
                <van-col
                  class="img-border"
                  :class="selectSkuNList[index][indexp]==indexx?'img-on-border':''"
                  v-for="(itemm,indexx) in itemp.prodPropValues"
                  :key="itemm.skuId"
                  @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)"
                >
                  <van-image :src="skuImgUrl[index][indexx] + `?x-oss-process=image/resize,w_ ${clientWidth < 400 ? 70 : clientWidth}`" fit="scale-down"/>
                  <!-- <van-image :src="skuImgUrl[index][indexx]" fit="scale-down"/> -->
                  <van-row class="row-text-color">{{itemm.propValue}}</van-row>
                </van-col>
              </van-row>
              <van-tag
                v-if="indexp==1"
                v-for="(itemm,indexx) in itemp.prodPropValues"
                plain
                :key="itemm.skuId"
                :type="selectSkuNList[index][indexp]==indexx?'danger':'primary'"
                :color="selectSkuNList[index][indexp]==indexx?'': '#dcdfe6'"
                :text-color="selectSkuNList[index][indexp]==indexx?'': '#94979c'"
                class="tag"
                @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)"
              >{{itemm.propValue}}</van-tag>
            </van-row>
          </van-row>
        </div>
        <div>
          <van-row class="title-top">
            <div>{{$t('Guarantee.selected')}}</div>
          </van-row>
          <van-row class="selected-table">
            <van-row class="selected-head back-table">
              <van-col span="8" class="selected-left">{{$t('Guarantee.Commodity_pic')}}</van-col>
              <van-col span="8">{{$t('Guarantee.Options')}}</van-col>
              <van-col span="8">{{$t('Guarantee.num')}}</van-col>
            </van-row>

            <van-row
              class="selected-head table-borders"
              v-for="(item,index) in selectComboList.comboProds"
              :key="index"
            >
              <van-col span="8" class="selected-left">
                <van-image width="80" height="80" fit="scale-down" :src="pic[index]  + `?x-oss-process=image/resize,w_ ${clientWidth < 414 ? 80 : clientWidth }`" />
              </van-col>
              <van-col span="8" class="table-right">{{properties[index]}}</van-col>
              <van-col span="8" class="table-right">{{countList[index]}}</van-col>
            </van-row>
          </van-row>
        </div>
        <!-- <div style="display: flex;justify-content: space-between;padding: 20px;">
          <div>
            <p style="font-size:22px;font-family: 'Bold';">{{$t('Guarantee.Total_price')}}</p>
          </div>
          <div>
            <b style="font-size:18px;color:#FC2A62">{{$t('Pay.money')}}{{ formatPrice(comboList.price)}}</b> 
            <span style="font-size:14px;color:#98989E">{{$t('detail.carriage')}}:{{$t('Pay.money')}}0</span>
          </div>
          
        </div> -->
        <van-row class="title-top">
            <div>{{$t('Guarantee.Total_price')}}</div>
          </van-row>
          <van-row class="costss">
            <div>{{$t('detail.carriage')}}:{{$t('Pay.money')}}{{combofareText || 0}}</div>
          </van-row>
          <van-row class="costss costs-red">
            <div>{{$t('Guarantee.Finally_cope')}}:{{$t('Pay.money')}}{{ formatPrice(Number(comboList.price) + Number(combofareText || 0))}}</div>
          </van-row>
        <van-row class="title-top"></van-row>
        <div class="form-body">
          <van-row class>
            <div class="form-title">{{$t('detail.paypaly_method')}}<span style="color:#FC2A62">*</span></div>
             <van-row class="form-radio" type="flex" justify="space-around">
                <van-col
                  v-for="(item,index) in paypalList"
                  :key="index"
                  span="6"
                  class="form-radio-type"
                  @click="isPaypalList(index+1)"
                  :class="{'form-paypal-selected':radioPaypalSelected==index+1}"
                ><img :src="item.icon" style="max-height:25px">{{item.lable}}</van-col>
              </van-row>
          </van-row>
          <van-row class>
            <div class="form-title">{{$t('detail.Delivery_method')}}<span style="color:#FC2A62">*</span></div>
          </van-row>
          <van-row class="form-radio" type="flex" justify="space-around">
            <van-col
              v-for="(item,index) in sendItems"
              :key="index"
              span="6"
              class="form-radio-type"
              @click="onradioSelected(index+1)"
              :class="{'form-radio-selected':radioSelected==index+1}"
            >{{item.name}}</van-col>
          </van-row>
          <van-row class>
            <span class="form-title">{{$t('data.Recipient_name')}}</span><span style="color:#FC2A62">*</span>
            <van-field v-model="userData.name" class="field" />
          </van-row>
          <van-row class>
            <span class="form-title">{{$t('order.phone')}}</span><span style="color:#FC2A62">*</span>
            <van-field v-model="userData.phones" type= "number" :maxlength="maxlength" class="field" />
          </van-row>
          <van-row class v-if="isIndonesia">
            <span class="form-title">Kode verifikasi</span><span style="color:#FC2A62">*</span>
            <div class="Vcode">
              <van-field v-model="userData.vCOde" v-on:blur="getonBlur()" type= "number" :maxlength="6" class="field" />
              <van-button :disabled="isBtndisable" style="background:#FC2A62;border-radius:4px;color:white;padding:0" @click="getVcode">{{countss}}<span v-show="iscountText">{{countText}}</span> </van-button>
            </div>
          </van-row>
          
          <span class="form-title">{{$t('order3.Select_address')}}</span><span style="color:#FC2A62">*</span>
          <van-row class style="padding: 10px 0;">
            <van-row>
              <van-dropdown-menu v-if="oneShow">
                <van-dropdown-item v-model="area1" :options="area1Data" @change="listByPid" />
              </van-dropdown-menu>
            </van-row>
            <van-row>
              <van-dropdown-menu>
                <van-dropdown-item v-model="area2" :options="area2Data" @change="listByPid" />
              </van-dropdown-menu>
            </van-row>
            <van-row>
              <van-dropdown-menu v-if="onShows">
                <van-dropdown-item v-model="area3" :options="area3Data" @change="onlistByPidThree" />
              </van-dropdown-menu>
            </van-row>
            <van-row>
              <van-dropdown-menu v-if="area4Show">
                <van-dropdown-item v-model="area4" :options="area4Data" @change="onlistByPidFour"   />
              </van-dropdown-menu>
            </van-row>
            <van-row>
              <van-dropdown-menu v-if="area5Show">
                <van-dropdown-item v-model="area5" :options="area5Data"  @change="onlistByPidFive" />
              </van-dropdown-menu>
            </van-row>
          </van-row>
          <van-row class v-show="!disableds">
            <span class="form-title">{{$t('order3.xxdz')}}</span><span style="color:#FC2A62">*</span>
            <van-field v-model="userData.detailed" class="field" disabled />
          </van-row>

          <van-row v-show="disableds">
            <span class="form-title">{{$t('order3.xxdz')}}</span><span style="color:#FC2A62">*</span>
            <van-field v-model="userData.detailed" class="field" />
          </van-row>

          <van-row class>
            <span class="form-title">{{$t('data.email')}}</span>
            <van-field v-model="userData.eMail" class="field" />
          </van-row>
          <van-row class>
            <span class="form-title">{{$t('Guarantee.message')}}</span>
            <van-field v-model="userData.stay" class="field" />
          </van-row>

           <van-row class v-if="postCodeShow">
              <span class="form-title">{{$t('Pay.postcode')}}</span>
              <van-field v-model="userData.postCode" class="field" type="number" />
            </van-row>
        </div>
        <div>
          <van-row class="form-button">
            <van-button style="background:#FC4270;color:#FFFFFF"  :disabled="flag" block @click="onSubmit">{{$t('detail.buy_now')}}</van-button>
          </van-row>
          <!-- 加入购物车 -->
          <!-- <van-row class="form-button form-text-color">
            <van-button type="default" @click="addCarList" block>{{$t('detail.add_cart')}}</van-button>
          </van-row> -->
        </div>
      </div>
      <div class="site">
        <span v-for="(item,index) in siteList" :key="index" @click="toDetail(item.id,item.region)">
          {{item.title}}
          <span v-if="index<(siteList.length-1)"></span>
        </span>
      </div>
     
    </div>

    <van-goods-action style="z-index:99" id="ljgm">
      <!-- <van-goods-action-button type="danger" :disabled='flag' :text="$t('Product_details_page.Buy_now')" @click="buyNow" /> -->
      <van-goods-action-button
        style="border-radius: 0;margin:0;background:#FC4270;color:white;height:100%"
        :text="$t('Product_details_page.Buy_now')"
        @click="tooffset"
      />
    </van-goods-action>
   
    
      

  </div>
</template>

<script>
import {
  Rate ,
  Image as VanImage,
  Card,
  Button,
  DropdownMenu,
  DropdownItem,
  Field,
  Swipe,
  SwipeItem,
  Toast,
  Grid,
  GridItem,
  Tag,
  Image,
  Lazyload,
  Stepper,
  ActionSheet,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  NavBar
} from "vant";
import { mapMutations, mapState } from "vuex";
import { findIndex, remove, cloneDeep } from "lodash";
import goods from "@/api/goods";
import { getQueryVariable,compare } from "@/utils/index";
import home from "@/api/home";
import { roc_711 } from "../../../../static/roc_711";
import { roc_qj } from "../../../../static/roc_qj";
import { roc_tw } from "../../../../static/roc_tw - OK";
import { roc_tw_new } from "../../../../static/roc_tw - newOK";
import { moneys } from "../../../../static/moneyString"
import { Url  } from '@/utils/const'
// import language from './index/common/Language';
export default {
  // components: {language},
  data() {
    return {
      num:0,
      isBtndisable:false,
      isIndonesia:false,
      issubmit:false,
      iscountText:false,
      countText:'Kembalilah dalam beberapa detik',
      countss:"kode verifikasi",
      orderItemNums:1,
      ProdListName:[],
      priceTitle:'',
      combofareText:'',
      brief:true,
      index: 0,
      onButtom: true,
      oneShow:false, // 如果是宅配的 那么隐藏掉第一级的联动
      Request:true,//防抖
      isPage:null,
      fbnum:0,
      maxlength:'20',
      // textData:'',
      textShow:false,
      radios:'0',
      fileList:[],//上传的图片
      message:'', //评论内容
      prodCommListImg:[],
      prodCommList:[],
      buyShow:false,
      buy:'',
      itemsIsShow:true,
      countList:[],
      moneysString:'',
      disableds: true,
      postCodeShow:false,
      getValue: 1,
      areaCode: "",
      area1: -1,
      area1Data: [],
      area2: -1,
      area2Data: [],
      area3: -1,
      area3Data: [],
      area4: -1,
      area4Data: [],
      area5:-1,
      area5Show:false,
      area5Data:[],
      area4Show:false, // 第四级联动
      pid: "",
      address: {},
      userData: {
        name: "",
        phones: "",
        address: "",
        detailed: "",
        eMail: "",
        stay: "",
        postCode:""
      },
      errorInfo: {
        nameValue: false,
        emailValue: false,
        phoneValue: false,
        arrNameValue: false,
        arrPhoneValue: false
      },
      radioSelected: 1,
      radioPaypalSelected:1,
      sku: {
        tree: [],
        list: [],
        price: "11", // 默认价格（单位元）
        stock_num: 227, // 商品总库存
        collection_id: 2261, // 无規格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无規格商品
        hide_stock: false // 是否隐藏剩余库存
      },
      show: false,
      goods: {
        transport: {},
        skuList: [{}],
        comboParams: [{}]
      },
      skuGoods: {},
      selectedSku: {},
      selectedNum: 1, //商品數量的选择
      imgList: [],
      selectSkuNList: [[]], //套餐中选中的規格数组
      skuImgList: [[]], //規格商品的图片
      cartShow: false, //购物车页面
      comboList: {
        //套餐详情
        title: "", //套餐标题
        oriPrice: "", //套餐原价
        price: "", //套餐价格
        index: 0
      },
      titleName: "", //标题名字
      comboParams: [],
      selectComboList: [], //选中的套餐的产品列表
      selectSkuImgList: [], //选中的套餐的产品列表--颜色
      selectSkuImgTextList: [[]], //选中的套餐的产品列表--文字
      selSkuNameList: [], //选中的产品的规格列表
      skuIndexList: [[]], //选中的产品的规格列表
      skuId: [],
      pic: [],
      descs:'',
      properties: [],
      shopId: "",
      siteList: [],
      flag: false,
      Lumpuhkan: [],
      sendPop: false,
      show: false,
      radio: "1",
      sendItems: [],
      isactive: true,
      skuImgUrl:[],
      onShows:true,
      items:[],
      skuImgData:[],
      newRadios:'',
      newRadiosData:'',
      paypalList:[
        {
          // icon:'https://images.zzsbx.com/upload/20200925/5fd714bf885640e9b6fa69791b2c0b49.png',
          lable:this.$t("detail.paypaly1"),
          value:1
        },
        {
          icon:`https://images.zzsbx.com/upload/20200925/ab6e445de9dd40588f2bdb1366cfab42.png`,
          lable:this.$t("detail.paypaly2"),
          value:2
        }
      ]
    };
  },
  computed: {
    count: {
      get() {
        let cartGoods = this.$store.state.goods.shopCardGoods;
        let count = cartGoods.reduce((total, item) => total + item.num, 0);
        return count;
      }
    },
    orderGoods: {
      get() {
        return this.$store.state.goods.orderGoods;
      },
      set(val) {}
    },
    regionData: {
      get() {
        
        return this.$store.state.user.regionData;
      }
    },
  },
  watch: {
    regionData: {
      handler(newValue,oldValue){ //当改变时执行事件
        // console.log('new',newValue)
        // this.getcountry();
        this.$Fbq.getFbqId('',newValue.shopId); //fbq像素
      }
    }
  },
  destroyed() {},
  created() {
    let clientWidth = document.documentElement.clientWidth
    this.clientWidth = clientWidth
    this.process = "?x-oss-process=image/resize,w_" + clientWidth
    var str=this.$session.get('moneyString');
    this.moneysString=moneys[str];
    window.addEventListener("scroll", function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      try {
        var topPin = $("#ljxd").offset().top - 50; // console.log('topPin',topPin)
        if (scrollTop > topPin) {
          $("#ljgm").css("display", "none");
          
        } else {
          $("#ljgm").css("display", "block");
        }
      } catch (error) {}
    });

    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      loadingType: "spinner"
    });
    
    this.titleName = this.$store.state.designer.titleName;
    let param1 = this.$route.params || {};
    // let hrefs = window.location.href.split("#");
    // let spilt = hrefs[1].split("?");
    // var url = location.search; //获取问号后面的参数
    // console.info("url:", hrefs[1]);
    // let spilt= window.location.href;
    let sysUserId, orderSource;
    // if (spilt.length > 1) {
    //   sysUserId = getQueryVariable(spilt[1], "sysUserId");
    //   orderSource = getQueryVariable(spilt[1], "orderSource");
    //   // console.info(sysUserId, "------", orderSource);
    //   this.$session.set("sysUserId", sysUserId); //获取userId
    //   this.$session.set("orderSource", orderSource);
    // }
    
    let param = {
      prodId: param1.prodId
    };

    if (param1.type == "tag") {
      //商品列表中的详情接口
      goods.tagProdInfo(param).then(res => {
        if (res.shopId) {
          this.shopId = res.shopId;
          this.$store.commit("designer/setShopId", res.shopId);
        }
        if (res.isPlay == 1) {
          //0表示不显示,1 显示
          this.getSiteList(res.shopId);
        }
        if (res.dyRop) {
          this.dyRop(res.dyRop);
        }
        Toast.clear();
        this.comboParams = res.comboParams;
        this.selectComboList = this.comboParams[this.comboList.index];
        let selectComboList = cloneDeep(this.selectComboList);
        this.selectComboList = selectComboList;
        this.changeSelList();

        // console.info('-----全部的数据:',this.selectComboList)


        //默认选中的套餐
        if (res.comboParams[0].title) {
          this.comboList.title = res.comboParams[0].title;
        }
        if (res.comboParams[0].oriPrice) {
          this.comboList.oriPrice = res.comboParams[0].oriPrice;
        }
        if (res.comboParams[0].price) {
          this.comboList.price = res.comboParams[0].price;
        }
        if (res.comboParams[0].index) {
          this.comboList.index = res.comboParams[0].index;
        }
        this.goods = res;
        this.getSkuList();
      });
    } else {
      goods.goodsInfo(param.prodId).then(res => {
        if(res.region == 'Indonesia'){
          this.isIndonesia = true
        }
        // this.FbShopId = res.shopId
        let imgs =  res.content.replace(/.jpg/g,'.jpg' + this.process)
        this.getSiteList(res.shopId,res.region)
        this.changePay2(res.region)
        if(res.brief== '' || res.brief== ' ' || res.brief== null){
          this.brief =false
        }
        this.comboFareList = JSON.parse(res.combo)
        this.combofareText = this.comboFareList.dynamicItem[0].comboFare
        this.descs = res.descs
        this.priceTitle =res.title
        this.buyShow = res.isReview;
        // console.info(this.buyShow)
        this.prodId = res.prodId
        
        // debugger
        this.newRadios= res.region||"台灣";
        
        // debugger
        this.onNew(res.shopId)
        this.getProdCommList(param.prodId);
        this.items = res.prodTagList;
        this.skuImgData=res;
        this.skuImgDatas();
        var arr = res.delivery.split(",");
        arr.forEach((item, index) => {
          var datas;
          if(item.indexOf('宅配')!=-1){
             datas = { id: 1, name: item };
          }else if(item.indexOf('全家')!=-1){
             datas = { id: 3, name: item };
          }else if(item.indexOf('711')!=-1){
             datas = { id: 2, name: item };
          }else if(item.indexOf('OK')!=-1){
            datas = { id: 4, name: item };
          }else if(item.indexOf('萊爾富')!=-1){
            datas = { id: 5, name: item };
          }else{
            datas = { id: 6, name: item };
          }
          // console.info(datas);
          this.sendItems.push(datas);
        });
        this.sendItems.sort(compare('id'))//排序
        if (res.shopId) {
          this.shopId = res.shopId;
          this.$store.commit("designer/setShopId", res.shopId);
        }
        if (res.isPlay == 1) {
          //0表示不显示,1 显示
          // this.getSiteList(res.shopId,res.region);
        }
        if (res.dyRop) {
          this.dyRop(res.dyRop);
        }

        Toast.clear();
        // console.log("====res=====", res);
        this.comboParams = res.comboParams;
        this.selectComboList = this.comboParams[this.comboList.index];
        let selectComboList = cloneDeep(this.selectComboList);
        this.selectComboList = selectComboList;
        this.changeSelList();

        //默认选中的套餐
        if (res.comboParams[0].title) {
          this.comboList.title = res.comboParams[0].title;
        }
        if (res.comboParams[0].oriPrice) {
          this.comboList.oriPrice = res.comboParams[0].oriPrice;
        }
        if (res.comboParams[0].price) {
          this.comboList.price = res.comboParams[0].price;
        }
        if (res.comboParams[0].index) {
          this.comboList.index = res.comboParams[0].index;
        }
        this.goods = res;
        this.goods.content = imgs;
        this.getSkuList();
      });


     

    }
    // var nums = 0
    //检测滑动到底部
    window.onscroll = function() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; //变量windowHeight是屏幕可用工作区高度
      var windowHeight = window.screen.availHeight; //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; //滚动条到底部的条件
        // console.info(scrollTop)
        if(scrollTop>350){
            $(".scroll").css("position","static");
        }else{
            $(".scroll").css("position","absolute");
        }
      // if (scrollTop + windowHeight >= scrollHeight-220) {
      //    if(nums==0){
      //        fbq('track', 'AddToCart');
      //        nums++
      //     }
      // }
    };
  },
  
  mounted(){
  },
  methods: {
    getVcode(){
      let params = {
        areaCode:this.areaCode,
        // areaCode:86,
        region:this.pid,
        telephoneNumber:this.userData.phones,
      }
      if(this.pid =='Indonesia'){
        if(this.userData.phones){
          if(this.userData.phones.substring(0,1)!='8'){
            //  电话请以8开始
            Toast('telepon Silakan mulai dari 8');
            // 必须从8开始
            return false;
          }else{
            goods.getVcode(params).then(data=>{
              console.log(data)
            })
          }
        }else{
          // Toast(this.$t("detail.paypalyOut"));
          Toast('Telepon tidak boleh kosong')
          // 电话不能为空
          return false
        }
      }
      // if(!this.userData.phones){
      //   Toast(this.$t("detail.paypalyOut"));
      //     return false
      //   }else{
      //     goods.getVcode(params).then(data=>{
      //     console.log(data)
      //   })
      // }
      this.isBtndisable = true
      const TIME_COUNT = 60
      this.iscountText = true
      if (!this.timer) {
        this.countss = TIME_COUNT
        // this.show = false
        this.timer = setInterval(() => {
          if (this.countss > 0 && this.countss <= TIME_COUNT) {
            this.countss--
          } else {
            // this.show = true
            clearInterval(this.timer)
            this.iscountText = false
            this.countss = 'Kode verifikasi'
            // this.iscountText = !this.iscountText
            this.isBtndisable = false
            // this.countText = 'Kembalilah dalam beberapa detik'
            this.timer = null
            // 跳转到选人加分界面
            // this.$router.push('/')
          }
        }, 1000)
      }
      
      
    },
    getonBlur(){
      if(!this.userData.phones){
        Toast('Nomor telepon tidak boleh kosong');
        // 电话不能为空
        return false
      }
      let params = {
        content: this.userData.vCOde,
        telephoneNumber:this.userData.phones,
      }
      goods.Vercode(params).then(data=>{
        if(data === 0){
          this.issubmit = true
        }else{
          this.issubmit = false
        }
        
      })
    },
    getIspay(){
        this.paypalList.forEach((item,index)=>{
        this.paypalList[0].lable = this.$t("detail.paypaly1")
        this.paypalList[1].lable = ''
      })
    },
    isPaypalList(index){
      if(index == 2 && !this.skuImgData.isPay){
        Toast(this.$t("detail.paypalyOut"));
        // this.radioPaypalSelected = index;
      }else{
        this.radioPaypalSelected = index;
      }
      
    },
    addProdCommList(){
        let str = [];
        this.fileList.forEach((item,index)=>{
            str.push(item.content)
        })
        if(!this.message){
          Toast("評論失敗，請輸入内容");
          return false;
        }
        let datas={
          content:this.message,
          evaluate:Number(this.radios) ,
          pics:str,
          prodId:Number(this.$route.params.prodId) 
        }
        // console.info('添加成功',str)
        goods.addProdComm(JSON.stringify(datas)).then(data=>{
            Toast("評論成功");
            this.onButtom= false
            this.getProdCommList(this.$route.params.prodId)
            this.message=[];
            this.fileList=[];
            // console.info('添加成功',data)
        })
    },
    getProdCommList(id){
        goods.getProdComm({evaluate:-1,prodId:id}).then(data => {
          this.prodCommList=data.records;
          // this.prodCommList.forEach((item,index)=>{
          //   if(item.pics){
          //     if(item.pics.indexOf(',')!=-1){
          //       this.prodCommListImg.push(item.pics.split(","));
          //     }else{
          //       this.prodCommListImg.push(item.pics);
          //     }
          //   }
             
          // })
          // console.info(this.prodCommListImg)
        });
    },
    onNew(id){
      this.getIspay()
      // debugger
      if(this.$route.name==="Detail"){
        this.isPage = 1
        let att = ['林先生','林女士','方先生','方女士','黃先生','黃女士','漲先生','漲女士','陳先生','陳女士','鄭先生','鄭女士','龍先生','龍女士','施先生','施女士','李先生','李女士','曹先生','曹女士','廖先生']
        if(this.newRadios==='台灣'){
          setInterval(()=>{
              let index = Math.ceil(Math.random()*20);
              this.buy = `${att[index]}${index+30}秒前已購買`;
              this.textShow=!this.textShow;
          },2000)
        }
        
        goods.getArea({region:this.newRadios}).then(res => {
            this.newRadiosData = res;
            this.changePay2(res[0].areaName)
            this.getcountry();
            // this.$Fbq.getFbqId('',id); //fbq像素
            this.itemsIsShow = false
        });
  //       let url = location.host;
  //       home.region(url).then((res) => {
  //       })
      }else{
        // debugger
        goods.getArea({region:this.newRadios||-1}).then(res => {
          // console.log(res)
            this.newRadiosData = res;
            this.regAreaid = res[0].areaId
            this.changePay2(res[0].areaName)
            this.getcountry(res[0].areaId);
            // this.$Fbq.getFbqId('',id); //fbq像素
        });
        // let url = location.host;
  //       home.region(url).then((res) => {
  //         this.$Fbq.getFbqId('',sessionStorage.getItem('shopId')); //fbq像素
  //       })
         this.isPage = 0
         this.buyShow=this.buyShow;
        // if(this.area2Data.length<=0){
        //   this.getcountry();
        // }else{
        //   this.getcountry(1);
        // }
      }
    },
     changePay2(item) {
      if(item=='台灣'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "tw") : (this.$i18n.locale = "tw");
        sessionStorage.setItem('locale','tw')
      }else if(item=='Malaysia'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "ma") : (this.$i18n.locale = "ma");
        sessionStorage.setItem('locale','ma') 
      }else if(item=='日本'){
      let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "ja") : (this.$i18n.locale = "ja");
        sessionStorage.setItem('locale','ja')
      }else if(item=='ประเทศไทย'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "tg") : (this.$i18n.locale = "tg");
        sessionStorage.setItem('locale','tg')
      }else if(item=='Singapore'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "en");
        sessionStorage.setItem('locale','en')
      }else if(item=='香港'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "hk") : (this.$i18n.locale = "hk");
        sessionStorage.setItem('locale','hk')
      }else if(item=='Pilipinas'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "flb") : (this.$i18n.locale = "flb");
        sessionStorage.setItem('locale','flb')
      }else if(item=='Việt Nam'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "yn") : (this.$i18n.locale = "yn");
        sessionStorage.setItem('locale','yn')
      }else if(item=='Indonesia'){
        let locale = this.$i18n.locale;
        locale === "null" ? (this.$i18n.locale = "is") : (this.$i18n.locale = "is");
        sessionStorage.setItem('locale','is')
      }
      this.getIspay()
    },
    skuImgDatas(indexs){
        var index = indexs?indexs:0;
        this.countList = [];
        // console.info(this.skuImgData.comboParams[index].comboProds[0].prodId)
        var datasImg=this.skuImgData.comboParams[index].comboProds;
        datasImg.forEach((item,index)=>{
          // console.info(item.prodCount)
          this.countList.push(item.prodCount)
          var arr=[];
          item.productProps[0].prodPropValues.forEach((items,indexs) =>{
            var srcs=-1;
            // console.info(items)
            // debugger
            item.skuList.forEach((itemsp,indexsp)=>{
                var strings= itemsp.propertiesId;
                if(strings.indexOf(items.valueId+'')!==-1){
                    srcs=itemsp.pic;
                }
            })
            if(srcs!=-1){
                arr.push(srcs);
            }
          })
           this.skuImgUrl.push(arr)
        })
    },
    onlistByPidThree(id) {
      if (this.getValue > 1 && this.getValue < 6) {
        console.info(id);
        let Datalist = [];
        if(this.getValue===2){
            Datalist = roc_711;
        }else if(this.getValue===3){
            Datalist = roc_qj;
        }else if(this.getValue===4){
            Datalist = roc_tw;
        }else{
            Datalist = roc_tw_new;
        }
        var datas = Datalist.area_3;


        var arr =
          this.getDteailName(id, 3) +
          ",店名:" +
          datas[this.area1][this.area2][this.area3].POIName +
          ",店號:" +
          datas[this.area1][this.area2][this.area3].POIID +
          ",电话:" +
          datas[this.area1][this.area2][this.area3].Telno;
        var newArr = arr.replace(/\s*/g, "");
        this.userData.detailed = newArr;
      } else {
        if(this.area4Show){
          this.listByPid(id,3)
        }else{
          this.userData.detailed = "";
        }
      }
      if(this.area4Show && !this.area5Show){
        this.onlistByPidFive(id)
      }
    },
    onlistByPidFour(id){
      // debugger
      // console.log('this.area4Show',this.area4Show)
      // console.log('this.area5Show',this.area5Show)
      // if(this.area4Show && !this.area5Show){
      //   this.onlistByPidFive(id)
      // }
      this.listByPid(id,4)
    },
    onlistByPidFive(id){
      goods.getPostCode((id)).then(res=>{
        this.userData.postCode= res.postCode
      })
    },
    tooffset() {
      if(this.fbnum==0){
        let param = {
          'prodId':this.prodId,
          'shopId':this.shopId,
          'urlSource':location.href,
          'isPage':this.isPage,
        }
        goods.record(JSON.stringify(param)).then(res => {
          this.fbnum++
        })
       
      }
      var topPin = $("#ljxd").offset().top;
      // console.log("this.topPin", topPin);
      $("html,body").animate({ scrollTop: topPin + "px" }, 1000);
    },
    onNavBar(id){
        this.$router.push({path:"/GoodsCategory",query:{index:id}})
    },
    onSubmit() {
       if(this.num == 0){
         this.num++
         fbq('track', 'AddToCart');
       }
      // debugger
      this.$store.state.designer.List = this.selectComboList.comboProds
      this.$store.state.designer.imgList = this.properties
      this.$store.state.designer.numList = this.countList
      this.$store.state.designer.pic = this.pic
      if (!this.userData.name) {
        Toast(this.$t("Toast.inputName"));
        return false;
      }
      if (!this.userData.phones) {
        Toast(this.$t("Toast.inputPhone"));
        return false;
      }
      if(!this.userData.postCode&&this.postCodeShow){
        Toast(this.$t("Toast.inputZip"));
        return false;
      }
      if(this.userData.detailed == ''){
        Toast(this.$t("Toast.inputAddress"));
        return false;
      }
      var ten = -1;
      var noDetalied=['澎湖','金門','連江','媽祖','琉球鄉','綠島鄉','蘭嶼鄉','金寧鄉'];
      let string = this.getDteailName(this.area1, 1);
      noDetalied.forEach((item,index)=>{
        if(string.indexOf(item)!=-1){
            ten=1;
        }
      })
      if(ten==1){
        Toast(this.$t("Toast.inputAlertAddress"));
        return false;
      }
      let buyGoods = cloneDeep(this.selectComboList.comboProds);
      buyGoods.forEach((item, index) => {
        item.selectedSkuId = this.skuId[index];
        item.skuList.forEach((item_sku, index_sku) => {
          if (item_sku.skuId == this.skuId[index]) {
            item.selectedSkuPrice = item_sku.price;
            item.selectedSkuName = item_sku.properties;
          }
        });

        item.allPrice = this.selectComboList.price;
        item.selectedProdName = this.selectComboList.title;
        item.selectedProdId = this.goods.prodId;
        item["num"] = this.selectedNum;
      });
      this.refreshOrderGoods(buyGoods);
      let goodsData = this.$store.state.goods.orderGoods;
      let orderItems = []; //订单的産品列表
      let arrs=this.countList;
      goodsData.forEach(function(item, index) {
        orderItems.push({
          prodId: item.prodId,
          shopId: item.shopId,
          prodCount: arrs[index],
          skuId: item.selectedSkuId
        });
      });
      if (this.area3 == -1 && this.onShows) {
        Toast(this.$t("data.address"));
        return false;
      } else if (this.area2 == -1) {
        Toast(this.$t("data.address"));
        return false;
      }
      else if (this.area5Show &&this.area5 == -1) {
        Toast(this.$t("data.address"));
        return false;
      }
     if(this.area4Show && this.area4 == -1){
        Toast(this.$t("data.address"));
        return false;
     }
     
     if(this.pid=='台灣'){
       if(this.userData.phones.substring(0, 2)!='09'){
         Toast('台灣手機號碼必須以09開頭');
         return false;
       }else if(this.userData.phones.length!=10){
         Toast('台灣號碼必須是10位數');
         return false;
       }
     }else if(this.pid=='Indonesia'){
      //  if(this.userData.phones.length<7 || this.userData.phones.length>10){
      //     Toast('Panjang nomor salah');
      //     // 号码长度不正确
      //     return false;
      //  }
      // 判断地区是不是Indonesia 在判断号码是不i是8开头
        if(this.userData.phones.substring(0,1)!='8'){
          Toast('telepon Silakan mulai dari 8');
          // 电话请从8开始
          return false;
        }
        if(!this.userData.vCOde){
          this.issubmit = false
        }
        if(!this.issubmit){
          Toast('Kode verifikasi salah');
          // 验证码填写不正确
          return false;
        }
     }
      // let area1;
      // let area2;
      // let area3;
      // let areaAddress;
      // if(this.getValue=='3'){
      //     area1 = this.area1;
      //     area2 = this.getArea2Name(this.area2,1);
      //     area3 = this.getArea2Name(this.area3,2);
      //     areaAddress =  this.areaAddress
      //     if(area2=='請選擇'||area3=='請選擇'||areaAddress==''){
      //       addressStatus = true
      //     }
      // }else if(!this.address.addr){
      //   addressStatus = true
      // }
      // if(addressStatus){
      //   Toast('請選擇地址');
      //   return false
      // }
      let sysUserId = this.$session.get("sysUserId")
        ? this.$session.get("sysUserId")
        : " ";
      let r = /^\+?[1-9][0-9]*$/; //正整数
      let sysUserIdStatus = r.test(sysUserId);
      if (!sysUserIdStatus) {
        sysUserId = "";
      }
      // console.log("sysUserId", sysUserId);
      let addrWay;
      if (this.getValue == 1|| this.getValue ==6) {
        addrWay = "黑貓宅配";
      } else if (this.getValue == 2) {
        addrWay = "7-11";
      } else if(this.getValue == 3){
        addrWay = "全家";
      }else if(this.getValue == 4){
        addrWay = "OK";
      }else if(this.getValue == 5){
        addrWay = "萊爾富";
      }

      var demo = this.getDteailName(this.area2, 2);
      let param = {
        urlSource:window.location.href,
        shopId: goodsData[0].shopId, //店铺ID
        orderItems: orderItems,
        eMail: this.userData.eMail, //邮箱号码
        customerName: this.userData.name, //收件人姓名
        telephoneNumber: this.userData.phones, //收件人手机号码
        remarks: this.userData.stay, //订单备注
        addr: this.userData.detailed, //地址信息--详细地址
        cvsspot: this.address.cvsspot, //地址信息--店铺店名
        name: this.address.name, //地址信息--店铺店号
        dvyType: this.getSendName(this.getValue), //配送类型
        prodName: goodsData[0].selectedProdName, //套餐的套餐Id
        comboOnId: goodsData[0].selectedProdId, //套餐产品上级ID
        //黑貓宅配中的地址--三联地址
        area1: this.pid||this.newRadios||'台灣', //台灣
        area2: this.getDteailName(this.area2, 2), //市
        area3: this.onShows?this.getDteailName(this.area3, 3):'', //区
        area4: this.area4Show?this.getDteailName(this.area4, 4):'',
        area5: this.area5Show?this.getDteailName(this.area5, 5):'',
        address: this.userData.detailed, //详细地址
        sysUserId: sysUserId, //userId
        addrWay: addrWay, //选中的地址的类型--如7-11、全家、黑猫
        areaCode: this.areaCode,
        region: this.pid||this.newRadios||'台灣',
        postCode:this.userData.postCode+'',
        orderSource: this.$session.get("orderSource")
          ? this.$session.get("orderSource")
          : " "
      };
      // console.log("=======param======", JSON.stringify(param));
      if(this.Request){
        this.Request=false;
        goods.orderConfirm(JSON.stringify(param)).then(res => {
          if(this.radioPaypalSelected-1){
            sessionStorage.setItem('token_order',res.orderNumber)
            sessionStorage.setItem('numberValue',res.numberValue)
            console.log(res)
            let url = location.host;
             window.location.href = `/h5/payPal/createOrder?orderNumber=${res.orderNumber}`
            // goods.orderTem(res).then(res=>{
            //   console.log(',,,',res)
            // })
            //  window.location.href = `${url}/payPal/createOrder?orderNumber=${res}`
          }else{
            sessionStorage.setItem('token_order',res.orderNumber)
            sessionStorage.setItem('numberValue',res.numberValue)

            this.$router.push("/DetailSuccess");
          }
          this.Request=true;
          this.$session.set("sysUserId", "");
          let ids = [];
          goodsData.forEach(element => {
            ids.push({
              prodId: element.prodId,
              selectedSkuId: element.selectedSkuId
            });
          });
          this.removeShopCardGoods(ids);
          // if(res){
          //   this.$router.push("/DetailSuccess");
          // }
          // if (res) {
          //   if(this.$route.name==="Detail"){
          //       //  Toast("下單成功");
          //       this.$router.push("/DetailSuccess");
          //   }else{
          //       this.$router.push("/success");
          //   }
          // }
        });
      }
    },
    addCarList(){
      this.$store.state.designer.List = this.selectComboList.comboProds
      this.$store.state.designer.imgList = this.properties
      this.$store.state.designer.numList = this.countList
      this.$store.state.designer.pic = this.pic

      let buyGoods = cloneDeep(this.selectComboList.comboProds);
      buyGoods.forEach((item, index) => {
        item.selectedSkuId = this.skuId[index];
        item.skuList.forEach((item_sku, index_sku) => {
          if (item_sku.skuId == this.skuId[index]) {
            item.selectedSkuPrice = item_sku.price;
            item.selectedSkuName = item_sku.properties;
            this.ProdListName.push(item_sku.prodName)
          }
        });
        item.allPrice = this.selectComboList.price;
        item.selectedProdName = this.selectComboList.title;
        item.selectedProdId = this.goods.prodId;
        item["num"] = this.selectedNum;
      });
      this.refreshOrderGoods(buyGoods);
      let goodsData = this.$store.state.goods.orderGoods;
      let orderItems = []; //订单的産品列表
      let arrs=this.countList;
      goodsData.forEach(function(item, index) {
        orderItems.push({
          prodId: item.prodId,
          shopId: item.shopId,
          prodCount: arrs[index],
          skuId: item.selectedSkuId
        });
      });
      // console.log(orderItems)
      // console.log(this.properties)
      // sessionStorage.setItem('orderItems',JSON.stringify(orderItems))
      // console.log(sessionStorage.getItem('orderItems'))
      // let OBJ = {}
      this.properties.forEach((item,index)=>{
        orderItems[index].gg = item
      })
      this.countList.forEach((item,index)=>{
        orderItems[index].count = item
      })
      this.pic.forEach((item,index)=>{
        orderItems[index].pic = item
      })
      console.log(this.ProdListName)
      this.ProdListName.forEach((item,index)=>{
        orderItems[index].name = item
      })
      this.ProdListName = []
      
      sessionStorage.setItem(`orderItems${this.orderItemNums}` ,JSON.stringify(orderItems))
      this.orderItemNums++
      
    },

    ...mapMutations("goods", {
      removeShopCardGoods: "removeShopCardGoods",
      refreshOrderGoods: "refreshOrderGoods"
    }),
    getcountry(onSon) {
      // debugger
      // let url = location.host;
      // console.info(this.newRadiosData)
      let res={};
      if(this.$route.name==="Detail"){
        $(".goods").css("margin-top","0px");
        res=this.newRadiosData[0];
        let url = location.host;
        home.region(url).then(res => {
          this.$Fbq.getFbqId('',res.shopId); //fbq像素
        })
        //  this.getSiteList(this.shopId,res.areaName)
      }else{
        // res=this.regi
        res=this.newRadiosData[0];
        // debugger
      }
      // home.region(url).then(res => {
        // console.log("1111111111111111111111111111",res,'-------', this.$store.state.user.regionData);
        var dz = res.region||res.areaName;//获取国家
        this.areaCode = res.areaCode;//获取code;
        this.area1 = res.id||res.areaId;//获取国家id
        this.pid = this.newRadios //国家

        // debugger
        if(this.pid=='台灣'){
          this.maxlength="10";
        }else{
          this.maxlength="20";
        }
        if(this.pid=='日本'||this.pid=='Singapore'){
          this.onShows=false;
        }
        if(this.pid=='Việt Nam'||this.pid=='Pilipinas'||this.pid == 'ประเทศไทย'||this.pid == 'Indonesia'){
          this.area4Show = true;
        }
        if(this.pid == 'Indonesia'){
          this.area5Show = true;
        }
        if(this.pid=='台灣'||this.pid=='香港'){
            this.postCodeShow=false
        }else{
          this.postCodeShow=true
        }
        this.area1Data=[];
        this.area1Data.push({ text: this.$t("Guarantee.country"), value: -1 })
        var arr = {
          text: dz,
          value: this.area1
        };
        this.area1Data.push(arr);
        // debugger
        if(onSon!=1){
          // debugger
          this.listByPid(this.area1, 1);
        }else{
          this.listByPid(this.area1, 1);
        }
        // if(res.region !='台灣'){
        //  this.getValue = '3'
        // }
        // if(res.region =='日本'){
        //   this.isShow=false
        // }
      // });
    },
    getSendName(id) {
      return this.sendItems[Number(id) - 1].name;
    },
    getDteailName(data, index) {
      if(data==-1){
        return ' ';
      }
      var name;
      if(index===1){
        this.area1Data.forEach((item,index)=>{
          if(data==item.value){
             name = item.text;
          }
        })
      }else if(index < 4){
        var datas = index == 2 ? this.area2Data : this.area3Data;
        datas.forEach((item, index) => {
          if (data == item.value) {
            name = item.text;
          }
        });
      }else if(index == 4){
         var datas = this.area4Data;
          datas.forEach((item, index) => {
            if (data == item.value) {
              name = item.text;
            }
          });
      }else if(index == 5){
      var datas = this.area5Data;
        datas.forEach((item, index) => {
          if (data == item.value) {
            name = item.text;
          }
        });
      }
      
      return name;
    },
    listByPid(pid, index) {
      let param = { pid: pid == undefined ? "1" : pid };
      if (this.getValue == 1 || this.getValue == 6) {
        goods.listByPid(param).then(res => {
          var json = JSON.parse(
            JSON.stringify(res).replace(/areaId/g, "value")
          );
          var datas = JSON.parse(
            JSON.stringify(json).replace(/areaName/g, "text")
          );
          // console.info("ttttttttttttttttttttt", res, "----", json, datas);
          if (index == 1) {
            this.area2Data = datas;
            this.area2Data.push({
                text: this.$t("Guarantee.region"),
                value: -1
              });
              this.area2 = -1;
              this.area3Data.push({
                text: this.$t("Guarantee.region_s"),
                value: -1
              });
              this.area4Data.push({
                text: this.$t("Guarantee.village"),
                value: -1
              });
              this.area5Data.push({
                text: this.$t("Guarantee.villages"),
                value: -1
              });
          } else if(index==undefined){ //加载第三级
            this.area3 = -1;
            this.area3Data = datas;
            this.area3Data.push({
              text: this.$t("Guarantee.region_s"),
              value: -1
            });
          }else if(index == 3){  //加载第四级
            this.area3Data.forEach(item => {
              if(item.value==pid&&pid!=-1){
                // this.postCode =Number(item.postCode);
                // this.userData.postCode=Number(item.postCode);
              }
            });
            if(pid==-1){
               this.userData.postCode='';
            }
            //  console.info(this.postCode)
            this.area4 = -1;
            this.area4Data = datas;
            this.area4Data.push({
              text: this.$t("Guarantee.village"),
              value: -1
            });
          }else if(index == 4){  //加载第5级
            this.area4Data.forEach(item => {
              if(item.value==pid&&pid!=-1){
                // this.postCode =Number(item.postCode);
                // this.userData.postCode=Number(item.postCode);
              }
            });
            if(pid==-1){
               this.userData.postCode='';
            }
            //  console.info(this.postCode)
            this.area5 = -1;
            this.area5Data = datas;
            this.area5Data.push({
              text: this.$t("Guarantee.village"),
              value: -1
            });
          }
        });
      } else if (this.getValue >= 2 && this.getValue < 6) {
        let Datalist = [];
        if(this.getValue===2){
            Datalist = roc_711;
        }else if(this.getValue===3){
            Datalist = roc_qj;
        }else if(this.getValue===4){
            Datalist = roc_tw;
        }else{
            Datalist = roc_tw_new;
        }
        this.area2Data = [];
        Datalist.area_2[this.area1].forEach((item, index) => {
          var data = {
            text: item,
            value: index
          };
          this.area2Data.push(data);
          this.area2 = pid > 0 ? pid : 0;
        });
        this.area3Data = [];
        Datalist.area_3[this.area1][this.area2].forEach((item, index) => {
          var data = {
            text: item.Address,
            value: index
          };
          this.area3Data.push(data);
          this.area3 = 0;
        });

        var datas = Datalist.area_3;
        var arr =
          this.getDteailName(this.area3, 3) +
          ",店名:" +
          datas[this.area1][this.area2][this.area3].POIName +
           ",店號:" +
          datas[this.area1][this.area2][this.area3].POIID +
          ",电话:" +
          datas[this.area1][this.area2][this.area3].Telno;
        var newArr = arr.replace(/\s*/g, "");
        this.userData.detailed = newArr;
      }
    },
    getErrorMessage(key) {
      var value = String(this._data[key] || "").trim();
      switch (key) {
        // case 'nameValue':
        //   return value ? '' : '顧客名稱 是必須的';
        // case 'emailValue':
        //   return this.email(value) ? '' : '顧客電郵 是必須的';

        // case 'phoneValue':
        //   return this.isMobile(value) ? '' : '顧客電話號碼 是必須的';

        case "arrNameValue":
          return value ? "" : "收件人名稱 是必須的";

        case "arrPhoneValue":
          return this.isMobile(value) ? "" : "收件人電話號碼 是必須的";
        // case 'emailValue':
        //   return this.email(value) ? '' : '電子郵箱 是必須的';
      }
    },
    onradioSelected(index) {
      this.radioSelected = index;
       this.userData.postCode='';
      this.getValue = index;
      if (index == 1||index == 6) {
        this.oneShow = false; // 宅配的隐藏第一级
        if(this.pid=='Việt Nam'||this.pid=='Pilipinas'||this.pid == 'ประเทศไทย'){
          this.area4Show = true;
        }
        
        this.area1Data = [];
        if(this.pid=='日本'||this.pid=='Singapore'){
          this.onShows=false;
        }
        this.getcountry();
        this.userData.detailed = "";
        this.area3 = -1;
        this.area3Data = [{ text: this.$t("Guarantee.region_s"), value: -1 }];
        this.disableds = true;
      } else if (index >= 2 && index<6) {
        this.oneShow = true;
        if(this.pid=='Việt Nam'||this.pid=='Pilipinas'||this.pid == 'ประเทศไทย'){
          this.area4Show = false;
        }
        let Datalist=[];
         if(this.getValue===2){
            Datalist = roc_711;
        }else if(this.getValue===3){
            Datalist = roc_qj;
        }else if(this.getValue===4){
            Datalist = roc_tw;
        }else{
            Datalist = roc_tw_new;
        }
        this.onShows=true;
        // this.pid = "";
        this.disableds = false;
        this.area1Data = [];
        Datalist.area_1.forEach((item, index) => {
          var data = {
            text: item,
            value: index
          };
          this.area1Data.push(data);
        });

        this.area1 = 0;
        this.listByPid();
        // this.userData.detailed=this.getDteailName(this.area3,3)

        var datas = Datalist.area_3;
        var arr =
          this.getDteailName(this.area3, 3) +
          ",店名:" +
          datas[this.area1][this.area2][this.area3].POIName +
          ",店號:" +
          datas[this.area1][this.area2][this.area3].POIID +
          ",电话:" +
          datas[this.area1][this.area2][this.area3].Telno;
        var newArr = arr.replace(/\s*/g, "");
        this.userData.detailed = newArr;
        // console.info("-------", this.area1Data, "结尾");
      } 
      // else if (index == 3) {
      //   // this.pid = "";
      //   this.onShows=true;
      //   this.disableds = false;
      //   this.area1Data = [];
      //   roc_qj.area_1.forEach((item, index) => {
      //     var data = {
      //       text: item,
      //       value: index
      //     };
      //     this.area1Data.push(data);
      //   });
      //   this.area1 = 0;
      //   this.listByPid();
      //   // this.userData.detailed=this.getDteailName(this.area3,3)
      //   var datas = roc_qj.area_3;
      //   var arr =
      //     this.getDteailName(this.area3, 3) +
      //     ",店名:" +
      //     datas[this.area1][this.area2][this.area3].POIName +
      //     ",店號:" +
      //     datas[this.area1][this.area2][this.area3].POIID +
      //     ",电话:" +
      //     datas[this.area1][this.area2][this.area3].Telno;
      //   var newArr = arr.replace(/\s*/g, "");
      //   this.userData.detailed = newArr;
      // }
    },
    getSiteList(shopId,region) {
      //获取站点列表
      goods.topSiteList({ shopId: shopId ,region:region}).then(res => {
        this.siteList = res;
      });
    },
    toDetail(id,region) {
      //点击站点去到相对应的页面
      this.$router.push({ name: "siteDetail", params: { id: id ,region: region} });
    },
    imageUrlStatus(prodPropValues) {
      //判断规格中是否有图片
      let status = false;
      prodPropValues.forEach((item, index) => {
        if (item.imageUrl) {
          status = true;
        }
      });
      return status;
    },
    changeSelList() {
      //初始化辅助数组
      if (this.selectComboList.comboProds) {
        this.selectComboList.comboProds.forEach((itemc, indexc) => {
          this.selectSkuImgList.push(0);
          this.selectSkuNList[indexc] = new Array();
          this.skuIndexList[indexc] = new Array();
          itemc.productProps.forEach((item_p, index_p) => {
            this.selectSkuNList[indexc].push(0);
            this.skuIndexList[indexc][index_p] =
              item_p.prodPropValues[0].valueId;
          });
        });
      }
    },
    toSelectSkuName(index, indexx, indexp, valueId, item, itemp, itemm) {
      //选中的sku的名字
      // console.log(index, indexx, indexp, valueId, item, itemp, itemm);
      this.selectSkuNList[index][indexp] = indexx;
      let arr = cloneDeep(this.selectSkuNList);
      this.selectSkuNList = arr;
      this.skuIndexList[index][indexp] = valueId;
      this.getSkuList(arr);
      let propertiesStr = this.skuIndexList[index].join(",");
      item.skuList.forEach((ele, i) => {
        if (ele.propertiesId == propertiesStr) {
          // console.log("ele.status==0", ele);
          if (ele.status == 0) {
            Toast(this.$t("contactUs.shortSale"));
            this.flag = true;
            if (this.Lumpuhkan.length <= 0) {
              //如果数组没有， 那么先保存第一次点击的值
              var arr = { index: index, indexp: [indexp] };
              this.Lumpuhkan.push(arr);
            } else {
              //如果有， 就判断下当前的商品 颜色和尺码
              var hakim = -1;
              this.Lumpuhkan.forEach((key, val) => {
                if (key.index == index && key.indexp.indexOf(indexp) == -1) {
                  //判断这个数组对象对应商品是否有颜色和尺码没有就添加进去
                  this.Lumpuhkan[val].indexp.push(indexp); //保存操作的选项
                  // console.info('没有规格',key,val)
                }
                if (key.index == index) {
                  hakim = index;
                }
              });
              if (hakim == -1) {
                //如果没有， 那么就直接保存当前的操作
                var arr = { index: index, indexp: [indexp] };
                this.Lumpuhkan.push(arr);
              }
            }
          }
          if (ele.status == 1) {
            this.flag = false;
            this.Lumpuhkan.forEach((key, val) => {
              if (key.index == index) {
                //判断这个数组对象对应商品是否有颜色和尺码 有就将对应的按钮标识删除
                //  console.info('有这个',key,val)
                this.Lumpuhkan.splice(this.Lumpuhkan.indexOf(val), 1);
              }
            });
          }
        }
      });
      if (this.Lumpuhkan.length > 0) {
        this.flag = true;
      }
    },
    toSelectSkuImg(index, index_img, indexp, valueId) {
      //选中的sku的图片
      this.selectSkuImgList[index] = index_img;
      let selectSkuImgList = cloneDeep(this.selectSkuImgList);
      this.selectSkuImgList = selectSkuImgList;
      this.skuIndexList[index][indexp] = valueId;
      this.getSkuList();
    },
    getSkuList() {
      let selectCombo = this.selectComboList;
      var selectList = [];
      selectList = this.selectComboList.comboProds;
      this.skuIndexList.forEach((item, index) => {
        let skuIndex = "";
        item.forEach((item_m, index_m) => {
          skuIndex = skuIndex + item_m + ",";
        });
        skuIndex =
          skuIndex.substring(skuIndex.length - 1) == ","
            ? skuIndex.substring(0, skuIndex.length - 1)
            : skuIndex;
        selectList[index].skuList.forEach((item_s, index_s) => {
          if (skuIndex == item_s.propertiesId) {
            this.skuId[index] = item_s.skuId;
            this.pic[index] = item_s.pic;
            if(item_s.properties.indexOf(';') != -1){
               this.properties[index] = item_s.properties.split(';')[0].split(':')[1] + '   ' + item_s.properties.split(';')[1].split(':')[1] 
            }else{
              this.properties[index] = item_s.properties.split(':')[1]
            }
          }
        });
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    toSelectCombo(indexc, title, price, oriPrice) {
      // debugger
      this.skuImgUrl=[];
      this.skuImgDatas(indexc);
      //选择套餐
      // let arr = Array.from(this.comboFareList)
      this.combofareText = this.comboFareList.dynamicItem[indexc].comboFare
      this.Lumpuhkan = []; //清空商品选择
      this.comboList.index = indexc;
      this.comboList.title = title;
      this.comboList.price = price;
      this.comboList.oriPrice = oriPrice;
      this.selectComboList = this.comboParams[indexc];
      let arr = cloneDeep(this.selectComboList);
      this.selectComboList = arr;
      //选中的套餐的产品列表
      (this.properties = []),
        (this.skuId = []),
        (this.pic = []),
        (this.selectSkuNList = [[]]);
      this.selectSkuImgList = [];
      this.skuIndexList = [[]];
      this.changeSelList();
      this.getSkuList();
      // let comboList = cloneDeep(this.comboList)
      // this.comboList= comboList
    },
    addCarts() {
      //立即購買
      this.cartShow = true;
    },
    home() {
      this.$router.replace("/");
    },
    convertSku(skuList) {
      let v = [];
      let list = [];
      skuList.forEach((item, index, array) => {
        let vItem = {
          id: item.skuId,
          name: item.skuName,
          imgUrl: item.pic
        };
        v.push(vItem);
        let listItem = {
          id: item.skuId, // skuId，下单时后端需要
          price: item.price * 100, // 价格（单位分）
          sku_id: item.skuId, // 規格类目 k_s 为 s1 的对应規格值 id
          stock_num: item.stocks // 当前 sku 组合对应的库存
        };
        list.push(listItem);
      });
      this.sku = {
        tree: [{ k: "規格", k_s: "sku_id", v }],
        list,
        price: this.goods.price,
        stock_num: this.goods.totalStocks // 商品总库存
      };
    },
    ...mapMutations("goods", {
      addShopCardGoods: "addShopCardGoods",
      refreshOrderGoods: "refreshOrderGoods"
    }),
    formatPrice(price) {
      // return "NT$" + price;
      return +price;
    },
    getTransName(transport) {
      if (transport != undefined && transport != "") {
        return transport.transName;
      }
      return "";
    },
    onClickCart() {
      this.$router.push("/cart");
    },
    onBuyClicked(e) {
      if (e.selectedSkuComb == null) {
        Toast("請選擇一种規格");
        return;
      }
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = e.selectedSkuComb.sku_id;
      buyGoods.selectedSkuName = this.getSkuName(e.selectedSkuComb.sku_id);
      buyGoods.selectedSkuPrice = this.getSkuPrice(e.selectedSkuComb.sku_id);
      buyGoods["num"] = e.selectedNum;
      let goodsList = [buyGoods];
      this.refreshOrderGoods(goodsList);
      this.$router.push("/newOrder");
      this.show = false;
    },
    onAddCartClicked(e) {
      if (e.selectedSkuComb == null) {
        Toast("請選擇一种規格");

        return;
      }
      this.show = false;
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = e.selectedSkuComb.sku_id;
      buyGoods.selectedSkuName = this.getSkuName(e.selectedSkuComb.sku_id);
      buyGoods.selectedSkuPrice = this.getSkuPrice(e.selectedSkuComb.sku_id);
      buyGoods["num"] = e.selectedNum;
      this.addShopCardGoods(buyGoods);
      Toast(this.$t("tips.cart_success"));
    },

    getSkuName(skuId) {
      for (let i = 0; i < this.goods.skuList.length; i++) {
        if (this.goods.skuList[i].skuId === skuId) {
          return this.goods.skuList[i].skuName;
        }
      }
    },
    getSkuPrice(skuId) {
      for (let i = 0; i < this.goods.skuList.length; i++) {
        if (this.goods.skuList[i].skuId === skuId) {
          return this.goods.skuList[i].price;
        }
      }
    },
    addCart() {
      if (this.selectedSku.id == undefined || this.selectedSku.id == null) {
        // Toast('請選擇一种規格');
        this.show = true;
        return;
      }
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = this.selectedSku.id;
      buyGoods.selectedSkuName = this.selectedSku.name;
      buyGoods.selectedSkuPrice = this.getSkuPrice(this.selectedSku.id);
      buyGoods["num"] = this.selectedNum;
      this.addShopCardGoods(buyGoods);
      Toast(this.$t("tips.cart_success"));
    },
    buyNow() {
      // console.log("=====fbq=====", fbq);
      // fbq("track", "AddToCart");
      let buyGoods = cloneDeep(this.selectComboList.comboProds);
      buyGoods.forEach((item, index) => {
        item.selectedSkuId = this.skuId[index];
        item.skuList.forEach((item_sku, index_sku) => {
          if (item_sku.skuId == this.skuId[index]) {
            item.selectedSkuPrice = item_sku.price;
            item.selectedSkuName = item_sku.properties;
          }
        });

        item.allPrice = this.selectComboList.price;
        item.selectedProdName = this.selectComboList.title;
        item.selectedProdId = this.goods.prodId;
        item["num"] = this.selectedNum;
      });
      this.refreshOrderGoods(buyGoods);
      this.$router.push("/orderStep3");
    },
    stepperChange(e) {
      // console.log("====goodsList=", e);
      this.selectedNum = e;
    },
    skuSelected(e) {
      // console.log("====goodsList=", e);
      if (this.selectedNum == 0) {
        this.selectedNum = 1;
      }

      this.selectedSku = e.skuValue; 
    },
    dyRop(dyRop) {
      //抖音的像素
      sessionStorage.setItem("dyRop", dyRop);
      var ta = document.createElement("script");
      ta.type = "text/javascript";
      ta.async = true;
      ta.src = "https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid=" + dyRop;
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(ta, s);
    },
    changePay(item) {
      this.show = false;
      if (item == 1) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "tw");
      } else if (item == 2) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "zh");
      } else if (item == 3) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "en");
      } else {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "ma");
      }
    }
  }
};
</script>

<style lang="scss" scoped='scoped'>
  #ljgm{
    height: 60px;
  }
  .buy-body .van-radio-group{
      display: flex;
  }
  .switchs{
    position: relative;
    left: 65%;
  }
  .switchs span{
    position: relative;
    top: -5px;
  }
  .buy-body .van-button--large{
     height: 40;
     line-height: 40px;
  }
  .buy-body .van-radio {
     margin: 10px 0.25rem;
     white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
  }
  .buy-body .img-flex{
    margin:0 20px;
    display: flex;
    flex-wrap:wrap;
    margin-bottom: 20px;
    border-bottom: solid 1px #f3eeee;
    padding-bottom: 20px;
  }
  .prod-comm .van-card__thumb{
    width: 35px;
    height: 35px;
    margin-top: -2px;
  }
  .prod-comm .van-card{
    height: 50px;
    background: #fff;
  }
  .scroll-top{
    position: relative;
    top: -50px;
    position: sticky;
    top: 20px;
    
  }
  .scroll{
    // position: fixed;
    // top: 10px;
    position: absolute;
    top: -50;
    margin-left: 20px;
    width: 40%;
    line-height: 20px;
    background: #fff;
    border-radius: 20px;
    text-align: center;
    animation: 3s wordsLoop linear infinite normal;
    box-shadow: 0px 0px 4px #888888;
    font-size: 0.15rem;
  }
  @keyframes wordsLoop {
      0% {
          // transform: translateX(200px);
          // -webkit-transform: translateX(200px);
          opacity:1;
      }
      100% {
          // transform: translateX(-100%);
          // -webkit-transform: translateX(-100%);
          opacity:0;
      }
  }

  @-webkit-keyframes wordsLoop {
      0% {
          // transform: translateX(200px);
          // -webkit-transform: translateX(200px);
          opacity:1;
      }
      100% {
          // transform: translateX(-100%);
          // -webkit-transform: translateX(-100%);
          opacity:0.2;
      }
  }

.row-text-color {
  border-top: 1px solid #C6C6C6;
}
.img-border-row {
  display: flex;
  flex-wrap: wrap;
}
.img-border {
  border-radius: 5px;
  border: solid 1px #C6C6C6;
  width: 22%;
  // flex: 1;
  text-align: center;
  // padding:3px 0;
  overflow: hidden;
  margin: 5px 5px;
}
.img-on-border {
  border: solid 2px #f78491;
}
.notice {
  margin: 15px;
  // border: solid 1px #ccc;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  .notice-dt {
    // color: black !important;
    padding: 15px;
    font-weight: bold;
  }
  .notice-dd {
    padding: 0 15px;
    // color: rgba(0, 58, 117, 0.7) !important;
  }
  div,
  dl  {
    padding: 15px;
  }
}
.notice_span {
  height: 20px;
  font-size: 16px;
  background: rgba(0, 0, 0, 0.2);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
}

.form-button {
  padding: 0 20px;
  margin: 20px 0;
}
.form-text-color {
  color: red;
}
.van-dropdown-menu__bar {
  box-shadow: 0 0px 0px rgba(100, 101, 102, 0.08);
  border: solid 1px #dddddd;
  margin: 10px 0;
}
.form-radio {
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .van-col--6{
    width: auto;
    padding: 0 5px;
  }
  .form-radio-type {
    // width:30%;
    min-width:30%;
    width: auto;
    border: solid 1px #8c8c8c;
    text-align: center;
    line-height: 21px;
    margin: 0 5px;
    margin-bottom: 10px;
    border-radius: 3px;
    padding: 5px 10px;
  }
  .form-radio-selected {
    border: solid 1px #ee0a24;
    color: #ee0a24;
  }
  .form-paypal-selected {
    border: solid 1px #ee0a24;
    color: #ee0a24;
  }
}
.form-body {
  padding: 0 20px;
  .form-title {
    // font-family: 'Medium';
    font-size: 16px;
    padding:0 0 10px 0;
  }
  .field {
    border: 1px #ddd solid;
    border-radius: 0.12rem;
    margin: 10px 0;
  }
}
.costss {
  padding: 2% 5%;
  font-size: 14px;
  color: #8c8c8c;
}
.costs-red {
  font-size: 18px;
  font-weight: bold;
  color: EF0000;
  margin-top: 5px;
}
.title-top {
  // height: 11%;
  // font-family: 'Bold';
  width: 90%;
  padding: 2% 5%;
  border-top: 0.2rem solid #f5f5f5;
  font-size: 22px;
  font-weight: 600;
  margin-top: 10px;
}
.selected-table {
  width: 90%;
  margin: auto;
  border: 1px solid #f5f5f5;
  text-align: center;
  margin-bottom: 20px;
  .back-table {
    background: #E7E7E7;
  }
  .selected-head {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 30px;
    // .selected-left {
      // border-right: 1px solid #f5f5f5;
    // }
    // .table-right {
      // line-height: 140px;
    // }
  }
  .table-borders {
    border: solid 1px #f5f5f5;
    padding: 10px;
    padding-left: 0px;
  }
}

.huise {
  background: black;
}
// .goods .header_img, .goods .my-swipe{
//   height: auto !important;
// }
.goods {
  padding-bottom: 50px;
  margin-top: 40px;
  // .my-swipe {
    // height: 15rem;
    // height: auto !important;
    // height: auto;
  // }
  .header_img {
    width: 100%;
    // height: auto;
  }
  // .van-swipe__track{
    // height: 53%;
    // height: 56%;
  // }
  .van-image__img {
    height: auto;
  }
  &-title {
    font-size: 16px;
  }
  &-brief {
    font-size: 13px;
    // color: #d85757;
  }
  &-price {
    color: #f44;
    font-size: 18px;
    .source {
      font-size: 10px;
      color: #868788;
      text-decoration: line-through;
      padding-left: 10px;
    }
  }
  .sku_line_item {
    display: flex;
    color: #7c7d7d;
    font-size: 12px;
    justify-content: space-between;
  }
  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }
  &-cell-group {
    margin: 15px 0;
    .van-cell__value {
      color: #999;
    }
  }
  &-tag {
    margin-left: 5px;
  }
}
.border {
  border-top: 0.2rem solid #f8f8f8;
  border-bottom: 0.2rem solid #f8f8f8;
  color: #7c7d7d;
}
.color {
  color: #7c7d7d;
}
.sheets {
  // height: 80%;
  // overflow-y: hidden;
  z-index: 2004;
  // padding-bottom: 2rem;
  .title {
    // height: 11%;
    width: 90%;
    padding: 2% 5%;
    border-bottom: 0.2rem solid #f5f5f5;
    span {
      font-size: 0.65rem;
      font-weight: 550;
    }
    // .name{
    //   padding-left: 0.2rem;
    // }
    .money {
      color: #ca2e2e;
    }
    .orign {
      font-size: 0.5rem;
      color: #868788;
      text-decoration: line-through;
      padding-left: 0.5rem;
    }
  }
  .conts {
    // height: 60%;
    // overflow-y: scroll;
    padding-bottom: 5%;
  }
}

.combo {
  padding-bottom: 0%;
  .goodSheet {
    width: 90%;
    margin: 2% 5%;
    .van-col {
      // margin: 0 2%;
      line-height: 1.1rem;
    }
    .van-tag {
      margin: 0.2rem 0.1rem;
    }
  }
  .grid {
    width: 90%;
    margin-left: 5%;
    // margin-top: 0.5rem;
    .grid_item {
      .van_img {
        width: 1.8rem;
        height: 1.8rem;
        padding: 0.2rem;
        border: 0.05rem solid #e4e4e4;
        margin: 0.2rem;
      }
    }
    .select {
      .van_img {
        width: 1.8rem;
        height: 1.8rem;
        padding: 0.2rem;
        border: 0.05rem solid #e4e4e4;
        margin: 0.2rem;
        border: 0.05rem solid #ee0a24;
      }
    }
  }
}
.comboSelect {
  width: 90%;
  padding: 2% 3% 4% 3%;
  margin: 1%;
  border-bottom: 0.01rem solid #e2dfdf;
  .name {
    line-height: 1rem;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .list {
    .van-tag {
      margin: 0.2rem 0.1rem;
      // height: 1rem;
      height: 24px;
    }
    .select {
      color: #ca2e2e;
    }
  }
}
.skuName {
  font-size: 0.65rem;
  font-weight: 550;
  color: black;
}

.tag {
  padding: 3px 10px;
  margin: 0.2rem 0.15rem;
  height: 25px;
}
.nav_title {
  .van-nav-bar__left {
    .van-icon {
      color: #6f6f73;
    }
    .van-nav-bar__text {
      color: #6f6f73;
    }
  }
}
.content p image {
  height: auto;
}
.site {
  margin: 30px 0;
  text-align: center;
  padding: 0 30px;
  font-size: 14px;
  // font-family: 'Medium';
  display: grid;
}
.site span{
  padding: 5px 0;
}
.active {
  // height: 46px;
  // right:-16px
  margin: 0 -16px 2px 0;
}
.goods-price {
  color: black;
  font-size: 25px;
  padding: 15px 0 0 20px;
}
.goods-brief {
  // font-family: Bold;
  // border-top: 1px solid #ccc;
  padding-top: 10px;
}
.goods-brief span{
  color: white;
  margin-right: 7px;
  padding: 3px 5px;
  background: #FC2961;
  border-radius: 3px;
}
.goods-brief p{
  display: initial;
  font-size: 19px;
  // margin-left: 7px;
  color: #232323;
}
.goods-methods {
  // font-family: Medium;
  // margin-top: 15px;
  padding: 15px 0;
  // border-top: 1px solid #ccc;
}
.goods-methods div span:nth-child(1){
  background: #4E4A48!important;
}
.goods-methods div span{
  background: #2CCE96;
  padding: 3px 5px;
}
.goods-methods span {
  background: red;
  border-radius: 3px;
  margin: 10px 3px;
  color: white;
  padding: 2px;
}
.center {
  padding: 0 15px;
}
// .Swiper{
//   .c-swipe {
//     .c-swipe-wrapper{
      // height: auto !important;
//     }
//   }
// }
.c-swipe-pagination-item{
  background-color: #ebedf0!important;
  // width: 5px!important;
}
.c-swipe-pagination-item.active{
  background-color: white !important;
  width: 15px!important;
  z-index: 9999;
}
.c-swipe{
  height: max-content;
  // height: 46%;
}
.fontMoney{
  background-image: url(~@/assets/titleBage.png);
  background-position: center;
  background-position: -230px 0px;
  width: 100%;
  background-repeat: no-repeat;
  margin-top: -2px;
}
.fontMoney p{
  // font-family: title;
  // font-weight: bold;
  letter-spacing: 1px;
  font-size: 28px;
  color:rgba(255,255,255,1);
  padding:19px;
}
.van-tag--danger.van-tag--plain{
  color: #FC2A62!important;
}
.PackagePrice{
    // font-family: Bold;
    padding: 20px;
    font-size: 24px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    border-bottom: 7px solid #E7E7E7;
}
.PackagePrice span:nth-child(2){
  color: #FC2A62;
}
.van-row--justify-space-around{
  justify-content: flex-start;
}
.van-cell{
  padding: 5px 8px;
}
.form-radio .form-paypal-selected{
  border: solid 1px #FC2A62;
  color: #FC2A62;
}
.form-radio .form-radio-selected{
  border: solid 1px #FC2A62;
  color: #FC2A62;
}
.ProductDescription{
  text-align: center;
  // font-family: 'Bold';
  color: #FD2E64;
  padding: 0px 50px;
  line-height: 50px;
  font-size: 17px;
}
@media screen and (min-width: 750px) {
  .fontMoney{
    background-image: url(~@/assets/titleBage.png);
    background-position: center;
    background-position:  0px;
    width: 100%;
    background-repeat: no-repeat;
  }
}
// .form-radio-type:nth-child(2) img{
  // width: 34px;
// }
.van-card__price-currency{
  font-size: 16px;
}
.van-card__price{
  color: #ee0a24!important;
}
.Vcode{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Vcode div:nth-child(1){
  width: 40%;
  margin: 0 10px 0 0;
  min-width: 50%;
  width: auto;
}
.Vcode button{
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/detail/Detail2.vue